<script setup lang="ts">
import {useDate} from "@/composables/date";

interface Props {
    icon: string;
    date: string;
}

const { shortDate } = useDate();

const props = defineProps<Props>();
</script>

<template>
    <v-tooltip
        location="top"
        content-class="bg-black border-sm text-tooltip"
        max-width="200"
    >
        <template #activator="{ props: bind }">
            <div class="custom-text">
                <v-icon
                    size="x-small"
                    v-bind="bind"
                >
                    {{ props.icon }}
                </v-icon>{{ shortDate(props.date) }}
            </div>
        </template>
        <slot />
    </v-tooltip>
</template>

<style scoped>
.custom-text {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    font-size: 0.825rem; /* text-body-2 */
}
</style>
